import { useSeo } from '../hooks/useSeo';

export default function Background() {
  useSeo({ title: '이력', description: '학력, 공연 경력, 사사, 국문학 박사 논문 연구 소개' });
  return (
    <div>
      <h2>이력 및 학문적 배경</h2>
      <div className="section card">
        <h3>학력·수련</h3>
        <ul>
          <li>국립국악고등학교</li>
          <li>서울대학교 음대 국악과</li>
          <li>이화여자대학교 음대</li>
          <li>경희대학교 대학원 국어국문학 박사과정</li>
        </ul>
      </div>
      <div className="section card">
        <h3>공연·사사</h3>
        <p>판소리 다섯 마당을 명창들에게 사사하며 주요 공연(적벽가, 흥보가 완창 등)에 참여.</p>
      </div>
      <div className="section card">
        <h3>박사 논문</h3>
        <p>국문학 관점에서 판소리의 해학성, 서사 구조, 언어미학을 탐구하는 연구 진행 중.</p>
      </div>
    </div>
  );
} 